import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';
import format from 'date-fns/format';
import isNil from 'lodash/isNil';
import differenceInMinutes from 'date-fns/difference_in_minutes';
import Button from '~/components/common/Button';
import {push as changeURL} from 'react-router-redux';
import mapDispatch from '~/misc/mapDispatch';
import Results from './results/results';
import SearchForm from '../searchform/searchform';
import Tabs from '../tabs/tabs';
import RecentSearches from '../RecentSearches';
import Spinner from '~/components/common/Spinner';
import {
  loadsMore,
  loadsSort,
  lodasHideBroker,
  loadsCollectionTheCompany,
  loadCheck, loadCheckedAll,
  loadsNoCollectionCompsny,
} from '~/modules/loadsSearch/actions';
import {
  similarLoadsSort,
  similarHideBroker,
  similarCollectionTheCompany,
  similarLoadCheck,
  similarLoadCheckedAll,
  similarNoCollectionCompsny,
} from '~/modules/similarLoads/actions';
import AnonymousBanner from './AnonymousBanner';
import UserBanner from './UserBanner';
import SearchLoad from './searchLoad';
import LocationName from './LocationName';
import CityList from './cityList';
import Breadcrumb from './breadcrumb';
import {formatTimeDuration} from '~/misc/dates';
import Title from './Title';
import {form2query} from '~/misc/search';
import { getUrlQeury,getSearchQuery } from '~/misc/formatUrlquery';
import {loadsSearchAction} from '~/modules/loadsSearch/actions';
import {updateFromStateName} from '~/modules/geosearch/actions';
import * as modes from "~/modules/modal/modes";
import { track } from '~/misc/metrics';
import UpgradeEntrance from '~/pages/MembershipPlans/components/UpgradeEntrance'
import store from '~/store';
import {coerceQueryTypes} from '~/misc/search';
import {datesWithoutPast} from '~/misc/dates';
import {inputValuesAll} from '~/misc/equipment';

import css from './search.css';
import sharedCSS from '../shared.css';
import {modalChange} from "~/modules/modal/actions";
import { CommandSwiper } from '../CommandSwiper';
import { getDeeplink, removeQuery } from '~/misc/getQuery';
import parse from 'date-fns/parse';
import deeplink from '~/misc/deeplink';
// TODO: strip down connected search
const openDeeplink = () => {
  const [isMobile] = removeQuery(['isMobile']);
  if(isMobile) {
    setTimeout(()=> {
      window.location.href = deeplink.openSearch({hash: isMobile})
    }, 0)
  }
} 

const resultsCount = (count, one, many) => ({
  count: count,
  predicate : count === 1 ? one : many
})

const Matched = (props) => (
  <div data-qa='matches-result'>
    <span className={cs(css.matchedCount, 'qa-matched-count-main')}>
      { 
        props.showCount && 
        <span className={css.matchedCount_count}>{ props.showCount.count} </span>
      }
      { 
        props.showCount && 
        <span className={css.matchedCount_predicate}>{ props.showCount.predicate}</span>
      }
    </span>
    <span className={cs(css.matchedCountNew, 'qa-matched-count-new')}>
      {props.freshNum ? ` (+${props.freshNum} new)` : null}
    </span>
  </div>
);

const Header = connect(({
  loadsSearch: {query, allWithoutUnreaded, addedUnreaded, fetchedAt, tooManyUpdates, updatesEnabled},
  now: {minute},
}) => ({
  showCount: allWithoutUnreaded,
  freshNum: addedUnreaded,
  fetchedAt,
  origin: {
    city: query.from_city,
    state: query.from_state,
  },
  destination: {
    city: query.to_city,
    state: query.to_state,
  },
  tooManyUpdates: tooManyUpdates,
  updatesEnabled: updatesEnabled,
  outdated: differenceInMinutes(minute, fetchedAt) > 10 && (minute - fetchedAt),
}),mapDispatch({
  gotoAlert: (props) => changeURL('/alert/list')
}))(({freshNum, showCount, sorting, fetchedAt, origin, destination, updatesEnabled, tooManyUpdates, outdated, gotoAlert}) => (
  <div className={css.wrapper}>
    {/* <h1 className={css.mainHeader}>
      Loads to haul from {' '}
      <LocationName className={css.headerLocation} address={origin} /> to {' '}
      <LocationName className={css.headerLocation} address={destination}/>
    </h1> */}
    <div className={cs(css.resultsDescription, sorting !== false && css.resultsDescriptionAligned)}>
      <div className={css.resultsCountAndHits}>
        <Matched
          showCount={!isNil(showCount) && resultsCount(showCount, 'exact match', 'exact matches')}
          freshNum={freshNum}
        />
        <div className={css.fetchedAtMark}>
          Updated at <span className='qa-fetchedAt'>
            {format(fetchedAt, 'h:mm A')}
          </span>
        </div>
      </div>
      {fetchedAt && (
        <div className={cs({[css.refeshOutdated]: outdated})}>
          {outdated && `${formatTimeDuration(outdated)} ago. `}
          {!updatesEnabled && !tooManyUpdates && (<span>
            <span>Live updates were disabled. Search again to check updates</span><br/>
          </span>)}
          {!updatesEnabled && tooManyUpdates && (<span>
            <span>Live updates were disabled (too many updates). Search again to get more than 70 new loads</span><br/>
          </span>)}
        </div>
      )}
    </div>
    <div className={css.resultsActions} onClick={()=>gotoAlert()}>Set Load Alerts</div>
  </div>
));


const dateFromString = (dateString) => {
  if (dateString.length === 6) {
    const nums = dateString.match(legacyDate);
    if (!nums) {
      return null;
    }
    return parse(`20${nums[1]}-${nums[2]}-${nums[3]}`);
  }
  const date = parse(dateString);

  if (isNaN(date)) {
    return null;
  }

  return date;
};

const sortingOptions = ['age', 'dho', 'distance'];
const sortingDefault = 'age';
// emit 
const newLoadSearch = (query) =>{
  // 
  const date = Array.isArray(query.date) ? query.date : query.date && [query.date];
  const equipment = Array.isArray(query.equipment) ? query.equipment : [query.equipment];
  const dots = query.dots && (Array.isArray(query.dots) ? query.dots : [query.dots]);
  // store search form data according url query
  // below code is safety to pass though data to store
  setTimeout(() => {
    store.dispatch(
      loadsSearchAction(
        coerceQueryTypes({
          ...query,
          equipment: equipment.filter(i => inputValuesAll.includes(i)),
          sort_by: sortingOptions.includes(query.sort_by) ? query.sort_by : sortingDefault,
          from_name: query.from_name || '',
          to_name: query.to_name || '',
          date: datesWithoutPast(
            (date || []).map(dateFromString).filter(item => item),
            store.getState().now.date
          ),
          dots: dots,
        })
      )
    );
  }, 0);

}

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.showMore = this.showMore.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
  }

  componentWillMount() {
    const { searchLoads } = this.props;
    // url query is wrongly data
    // const urlQuery = getUrlQeury() || {}
    // console.log(`root search component will mount`,urlQuery);
    const { query } = this.props.location || {};
    console.log(`root search component will mount:`,this.props.location);
    track("view_load_search", {
      source: query.source || ''
    })
    const popup = query.popup;
    openDeeplink();
    if(popup === "ops"){ 
      searchLoads();
    }
    const state = query.from_state_name
    if (state) {
      this.props.updateGeoFromStateName(state)
    }
    // according to url query fill down search form
    if(query){
      newLoadSearch(query);
    }
  }
  componentWillReceiveProps(nextProps) {
    // refresh page when login

    const { query: oldQuery } = this.props.location || {};
    const { query: newQuery } = nextProps.location || {};
    if (!newQuery) return;
    const oldState = oldQuery.from_state || oldQuery.from_state_name;
    const newState = newQuery.from_state || newQuery.from_state_name;
    const oldCity = oldQuery.from_city;
    const newCity = newQuery.from_city;
    if (oldState !== newState || oldCity !== newCity) {
      console.log('newLoadSearch:',newQuery);
      newLoadSearch(newQuery);
      const state = newQuery.from_state_name
      if (state) {
        this.props.updateGeoFromStateName(state)
      }
    }
    // login success
    // if (nextProps.isLoggedIn !== this.props.isLoggedIn && nextProps.isLoggedIn) {
    //   this.props.loadsRefresh(this.props.loadsSearch.query);
    // }
  }

  render() {
    const {times} = this.props.memberSwitchData;
    const viewed = this.props.localLoadsClickTimes;
    const {accountLevel} = this.props.account;
    const mainData = this.props.loadsSearch;
    const {isL2User} = this.props;
    if (Object.keys(mainData).length === 0) {
      return <Title/>;
    }
    return (
      <div className={cs(sharedCSS.widewrap, "qa-content")}>
        {parseInt(accountLevel || 0) <= 1 &&
        !isL2User &&
        this.props.memberSwitchData.switch !== 0 ? (
          <div className={cs(css.notificationWrap)}>
            <div className={cs(css.notification)}>
              {times - viewed > 0 ? (
                <span className={css.notificationText}>
                  Daily free load views left: {times - viewed}
                </span>
              ) : (
                <span className={css.notificationText}>
                  Daily limit reached
                </span>
              )}
              <Button
                onClick={() => this.navigateTo()}
                className={css.submitButton}
              >
                Upgrade
              </Button>
            </div>
          </div>
        ) : null}
        <Title />
        {this.renderForm()}
        {<AnonymousBanner />}
        {<UserBanner />}
        <div data-qa="search-results" className="qa-search-results">
          {this.renderResults()}
        </div>
        <div className={sharedCSS.wideStretchable} style={{padding: 0, marginBottom: "12px"}}>
          <CommandSwiper></CommandSwiper>
        </div>
        <div className={cs('qa-similar-results', css.similarsWrap)} data-qa='similar-results'>
          {this.renderSimilar()}
        </div>
        <CityList />
        <UpgradeEntrance />
      </div>
    );
  }

  renderForm() {
    const {accountLevel} = this.props.account;
    return (
      < div className = {
        cs(sharedCSS.wideStretchable, sharedCSS.unpadded, css.wrap, parseInt(accountLevel || 0) <= 1 && this.props.memberSwitchData.switch !== 0 && css.addMargin)
      } >
        <Breadcrumb />
        <Tabs
          id='search'
          tabs={[
            {id: 'search', title: 'Search', dataqa: 'search'},
            {id: 'recent', title: 'Recent', dataqa: 'recent'},
          ]}
          csTabWarp = {css.tabWarp}
          csTabs={css.tabColunm}
          csTab={css.tab}
          csTabActive={css.tabActive}
          content={{
            search: <SearchForm advanced={true} isRevision={false} isclearParams={true}/>,
            recent: <RecentSearches/>,
          }}
        />
      </div>
    );
  }

  renderResults() {
    const mainData = this.props.loadsSearch;
    if (!mainData.status) {
      return null;
    }

    if (mainData.status === 'loading') {
      return <Spinner qa='search'/>;
    }

    if (mainData.status === 'error') {
      return (
        <div className={sharedCSS.wide}>
          <div className={css.errorWrap}>
            <div className={sharedCSS.h1}>Error occurred.</div>
            <div>Please try again.</div>
          </div>
        </div>
      );
    }

    return (
      <Results
        isSimilar={false}
        isMain={true}
        header={<SearchLoad isSimilar={false}/>}
        info={<Header/>}
        addedItemsFlat={mainData.addedItemsFlat}
        loadsSort={this.props.loadsSort}
        fetchedAt={mainData.fetchedAt}
        query={mainData.query}
        hasItems={mainData.hasItems}
        total={mainData.total}
        results={mainData.results}
        status={mainData.status}
        sorting={mainData.total > 0 || mainData.hasItems}
        checkedAll={mainData.checkedAll}
        checkClick={this.props.loadCheck}
        checkedAllClick={this.props.loadCheckedAll}
        showMore={this.showMore}
        identity={this.props.loadsSearch.identity}
        allowBanner={true}
        checkbox={true}
        hideBroker={this.props.lodasHideBroker}
        collectionTheCompany={this.props.loadsCollectionTheCompany}
        noCollectionCompany = {this.props.loadsNoCollectionCompsny}
        localSum={mainData.originalList}
        saveClick={true}
        hideClick={true}
      />
    );
  }

  renderSimilar() {
    const mainData = this.props.loadsSearch;

    if (mainData.status !== 'ok' && mainData.status !== 'refreshing') {
      return null;
    }

    const data = this.props.similarLoads;
    const zeroMainResults = data.total > 0 || data.hasItems;

    if (!data.status || (data.status === 'ok' && !zeroMainResults)) {
      return null;
    }

    if (data.status === 'loading') {
      return <Spinner qa='similar'/>;
    }

    const showCount = data.showCount && resultsCount(data.showCount, 'similar match', 'similar matches');
    return (
      <div>
        <div className={css.matchedNumber}>
          {<Matched showCount={showCount}/>}
        </div>

        <Results
          isSimilar={true}
          header={<SearchLoad isSimilar={true}/>}
          loadsSort={this.props.similarLoadsSort}
          query={data.query}
          hasItems={data.hasItems}
          total={data.total}
          results={data.results}
          status={data.status}
          sorting={zeroMainResults}
          identity={data.identity}
          checkedAll={data.checkedAll}
          checkClick={this.props.similarLoadCheck}
          checkedAllClick={this.props.similarLoadCheckedAll}
          checkbox={true}
          hideBroker={this.props.similarHideBroker}
          collectionTheCompany={this.props.similarCollectionTheCompany}
          noCollectionCompany={this.props.similarNoCollectionCompsny}
          localSum = {
            data.results && data.results.shipments
          }
          saveClick={true}
          hideClick={true}
        />
      </div>
    );
  }

  showMore(limit) {
    const mainData = this.props.loadsSearch;
    const newLimit = {limit: parseFloat(mainData.query.limit) + parseFloat(limit)};

    // FIXME: update location for keeping current state in query-string
    return this.props.loadsMore({...mainData.query, ...newLimit});
  }

  navigateTo() {
    const { showUpgradeToStandard } = this.props;
    showUpgradeToStandard();
  }
}

export default connect(({loadsSearch, similarLoads, user, account, premiumSwitch}) => ({
  loadsSearch,
  similarLoads,
  account: account,
  isLoggedIn: user.isLoggedIn,
  isL2User: user.isL2User,
  memberSwitchData: premiumSwitch.memberSwitchData,
  localLoadsClickTimes: premiumSwitch.localLoadsClickTimes,
}), mapDispatch({
  similarLoadsSort: (props, data) => similarLoadsSort(data),
  loadsSort: (props, data) => loadsSort(data),
  loadsMore: (props, data) => loadsMore(data),
  similarHideBroker: (props, data) => similarHideBroker(data),
  lodasHideBroker: (props, data) => lodasHideBroker(data),
  similarCollectionTheCompany: (props, data) => similarCollectionTheCompany(data),
  similarNoCollectionCompsny: (props, data) => similarNoCollectionCompsny(data),
  loadsCollectionTheCompany: (props, data) => loadsCollectionTheCompany(data),
  loadsNoCollectionCompsny: (props, data) => loadsNoCollectionCompsny(data),
  loadCheck: (props, id) => loadCheck(id),
  loadCheckedAll: () => loadCheckedAll(),
  similarLoadCheck: (props, id) => similarLoadCheck(id),
  similarLoadCheckedAll: () => similarLoadCheckedAll(),
  loadsRefresh: (props, data) => loadsSearch(form2query(data)),
  updateGeoFromStateName: (props, data) => updateFromStateName('search:origin-field', data),
  showUpgradeToStandard: (props) => modalChange('pop', {
    source: 'load-list',
    type: 'pop_upgrade_to_standard',
  }),

  showUpgradeToPremium: (props, data) => modalChange('pop', {
    times: data,
    source: 'load-list',
    type: 'pop_upgrade_to_new_standard',
  }),
  searchLoads: () => modalChange(modes.LOAD_DISAPPER, {type: "pop"}),
  gotoHp: (props, source) => changeURL(`/hp?${source}`),
}))(Search);



// WEBPACK FOOTER //
// ./src/components/search/search.js